var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDeleteOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 2C11.1038 2 12 2.8962 12 4H15C15.5523 4 16 4.44772 16 5C16 5.55228 15.5523 6 15 6H5C4.44772 6 4 5.55228 4 5C4 4.44772 4.44772 4 5 4H8C8 2.8962 8.8962 2 10 2Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.07284 7.97676C7.00823 7.42826 6.51121 7.036 5.96272 7.10062C5.41423 7.16523 5.02197 7.66225 5.08658 8.21074L6.03174 16.234C6.15038 17.2411 7.00395 18 8.01801 18H11.985C12.9991 18 13.8527 17.2411 13.9713 16.234L14.9165 8.21074C14.9811 7.66225 14.5888 7.16523 14.0403 7.10062C13.4918 7.036 12.9948 7.42826 12.9302 7.97676L11.985 16H8.01801L7.07284 7.97676Z",
  fill: "currentColor"
})));
export { SvgDeleteOutline20 as ReactComponent };